<template>
  <nav class="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-40">
    <div class="flex items-center justify-around h-16 px-2">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        @click="$emit('tab-change', tab.key)"
        :class="[
          'flex flex-col items-center justify-center flex-1 py-1 transition-colors',
          activeTab === tab.key 
            ? 'text-primary-500' 
            : 'text-gray-500 hover:text-gray-700'
        ]"
      >
        <!-- 图标 -->
        <div class="w-6 h-6 mb-1">
          <svg 
            v-if="tab.key === 'home'"
            class="w-full h-full" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
          </svg>
          
          <svg 
            v-else-if="tab.key === 'purchase'"
            class="w-full h-full" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
          </svg>
          
          <svg 
            v-else-if="tab.key === 'sales'"
            class="w-full h-full" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          
          <svg 
            v-else-if="tab.key === 'inventory'"
            class="w-full h-full" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
          </svg>
          
          <svg 
            v-else-if="tab.key === 'finance'"
            class="w-full h-full" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        </div>
        
        <!-- 标签文字 -->
        <span class="text-xs font-medium">{{ tab.label }}</span>
        
        <!-- 活跃指示器 -->
        <div 
          v-if="activeTab === tab.key"
          class="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-1 h-1 rounded-full indicator"
        ></div>
      </button>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'MobileTabBar',
  props: {
    activeTab: {
      type: String,
      default: 'home'
    }
  },
  emits: ['tab-change'],
  setup() {
    const tabs = [
      {
        key: 'home',
        label: '首页'
      },
      {
        key: 'purchase',
        label: '进货'
      },
      {
        key: 'sales',
        label: '销售'
      },
      {
        key: 'inventory',
        label: '库存'
      },
      {
        key: 'finance',
        label: '财务'
      }
    ]
    
    return {
      tabs
    }
  }
}
</script>

<style scoped>
button {
  position: relative;
}

/* 确保图标和文字垂直居中 */
.flex-col {
  min-height: 48px;
}

/* 文字颜色与主题联动 */
.text-primary-500 {
  color: var(--primary-500);
}

.hover\:text-gray-700:hover {
  color: #374151;
}

/* 活跃指示器颜色与主题联动 */
.indicator {
  background-color: var(--primary-500);
}

/* 点击反馈效果 */
button:active {
  transform: scale(0.95);
  transition: transform 0.1s ease-in-out;
}
</style>